import { Injectable } from '@angular/core';
import { WSService } from 'projects/core/src/include/service';
import { ToDo } from '../todo';
import { Globals } from 'projects/core/src/globals';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TodoService extends WSService<ToDo> {

  constructor() {super("todo"); }

  getTodoByAddress(id_address:any):Observable<any>{
      return Globals.ws.requestUrl<any>("todo","getTodoByAddress",[id_address]);
    }


  

}
